<template>
  <div class="event">
    <div class="pay">
        <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <Validate :form="form" v-if="email_view"></Validate>
      <form v-else class="app-pay-form" @submit.prevent="withdrawal">
        <slot name="content"></slot>
            <slot v-if="provider == 'maksipay_bank'">
                <div class="col">
                    <div class="inline-form">
                        <label>Banka <span style="color:var(--client-c3);">(Zorunlu)</span></label>
                        <select v-model="form.bank" :loader="_.isEmpty(withdrawalList)">
                            <option :value="null" disabled>Seçiniz</option>
                            <option v-for="item in withdrawalList" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="inline-form">
                        <label>IBAN <span style="color:var(--client-c3);">(Zorunlu)</span></label>
                        <input type="text" v-model="form.iban" placeholder="IBAN Numaranızı giriniz" autocomplete="off">
                    </div>
                </div>
                <div class="col">
                    <div class="inline-form">
                        <label>Şube Kodu (Zorunlu değildir)</label>
                        <input type="text" v-model="form.region" placeholder="Şube Kodu giriniz" autocomplete="off">
                    </div>
                </div>
                <div class="col">
                    <div class="inline-form">
                        <label>T.C Kimlik (Zorunlu değildir)</label>
                        <input type="text" v-model="form.identity" placeholder="T.C Kimlik giriniz" autocomplete="off">
                    </div>
                </div>
                <div class="col">
                    <div class="inline-form">
                        <label>Bir yakınınızın TC kimlik numarası (Zorunlu değildir)</label>
                        <input type="text" v-model="form.relative_identity" placeholder="Bir yakınınızın TC kimlik numarasını giriniz" autocomplete="off">
                    </div>
                </div>
                <div class="col">
                    <div class="inline-form">
                        <label>Doğum tarihi (Zorunlu değildir)</label>
                        <input type="text" v-model="form.birth_date" placeholder="Doğum tarihi giriniz" autocomplete="off">
                    </div>
                </div>
                <div class="col">
                    <div class="inline-form">
                        <label>Kimlik veriliş / Son kullanma tarihi (Zorunlu değildir)</label>
                        <input type="text" v-model="form.identity_date" placeholder="Kimlik veriliş / Son kullanma tarihi giriniz" autocomplete="off">
                    </div>
                </div>
            </slot>

            <slot v-else-if="provider == 'maksipay_crypto'">
                <div class="col">
                    <div class="inline-form">
                        <label>Coin <span style="color:var(--client-c3);">(Zorunlu)</span></label>
                        <select v-model="form.bank" :loader="_.isEmpty(withdrawalList)">
                            <option :value="null" disabled>Seçiniz</option>
                            <option v-for="item in withdrawalList" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="inline-form">
                        <label>Cüzdan No <span style="color:var(--client-c3);">(Zorunlu)</span></label>
                        <input type="text" v-model="form.account" placeholder="Cüzdan No yazınız" autocomplete="off">
                    </div>
                </div>
            </slot>
            
            <slot v-else>
                <div class="col">
                    <div class="inline-form">
                        <label>Cüzdan No <span style="color:var(--client-c3);">(Zorunlu)</span></label>
                        <input type="text" v-model="form.account" placeholder="Cüzdan No yazınız" autocomplete="off">
                        <div class="alert alert-danger" style="margin-top:10px" v-if="errorMessage">{{ errorMessage }}</div>
                    </div>
                </div>
            </slot>

            <div class="col">
                <div class="inline-form">
                    <label>Tutar</label>
                    <input :type="isMobile ? 'tel' : 'number'" placeholder="Çekim tutarınızı yazınız" v-model="form.amount">
                </div>
            </div>
            <div class="col" v-if="check_checkbox">
                <div class="inline-form">
                    <label>Kabul ediyorum</label>
                    <input type="checkbox" checked='checked' v-model="form.accept_rule"/>
                </div>
            </div>
            <div class="col">
                <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Çek'" />
            </div>
        </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'
 import Validate from '../../../../components/User/Pay/Validate'

  export default{
    props:['providerInfo', 'provider'],
    data(){
      return{
        btnLoading: false,
        form: {
            withdraw_validation_code:null,
            amount: null,
            accept_rule:null,
            provider: null,
            iban:null,
            region:null,
            bank:null,
            identity:null,
            relative_identity:null,
            birth_date:null,
            identity_date:null,
            wallet_id:null,
            wallet_address:null,
            account:null
        },
        loading: false,
        check_checkbox: false,
        withdrawalList: [],
        email_view: false,
        errorMessage:null,
      }
    },
    created()
    {
        if(this.provider == 'maksipay_crypto' || this.provider == 'maksipay_bank')
        {
            this.getWithdrawalList();
        }
        this.form.provider = this.provider;
    },
    methods:
    {
        getWithdrawalList()
        {
            axios.get('/user/wallet/withdrawal/maksipay/list', { params: { provider: this.provider }})
            .then((response) => {
                this.withdrawalList = response.data.list;
            })
            .catch((err) => {
            })
            .finally(() => {
            });
        },
        withdrawal() {

            if(this.provider == 'maksipay_papara' && _.size(this.form.account) != 10)
            {
                this.errorMessage = 'Papara hesap numarası 10 hane olmalıdır ve sadece sayılardan oluşmalıdır!';
                return false;
            }
            else if(this.provider == 'maksipay_pep' && _.size(this.form.account) != 9)
            {
                this.errorMessage = 'PeP hesap numarası 9 hane olmalıdır ve sadece sayılardan oluşmalıdır!';
                return false;
            }
            else if(this.provider == 'maksipay_hayhay' && _.size(this.form.account) != 11)
            {
                this.errorMessage = 'HayHay hesap numarası 11 hane olmalıdır ve sadece sayılardan oluşmalıdır!';
                return false;
            }

            this.btnLoading = true;
            axios.post('/user/wallet/withdrawal/maksipay/create', this.form)
            .then((response) => {
                if(response.data.email_view){
                    this.email_view = true
                    this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
                    return false
                }
                if (response.data.status) 
                {
                    this.$store.dispatch('wallet/setToPending', true);
                    this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
                }
            })
            .catch((err) => {
              if(err.response.data.email_verification){
                this.$router.push({ name: 'User', params: { section: 'security', payment: null } })
              }
            })
            .finally(() => {
                this.btnLoading = false;
            });
        },
    },
    components:{
      Header,
      Validate,
      Form
    }
  }

</script>